<template>
    <div class="animated fadeIn">
      <vue-loading :active="isLoading" loader="bars" :is-full-page="false"></vue-loading>
        <b-form inline>
          <b-form-group>
            <h3>Export</h3>
          </b-form-group>
          <b-form-group
            label="Status"
            description="Donation Status">
            <b-select :options="donationStatus" v-model="exportForm.status"></b-select>
          </b-form-group>
          <b-form-group
            label="Fields"
            description="Fields"
          >
            <b-form-select
              :multiple="true"
              :options="[
                {value: 'id', text: 'Id'},
                {value: 'status', text: 'Status'},
                {value: 'amount', text: 'Amount'},
                {value: 'person', text: 'Person'},
                {value: 'personEmail', text: 'Person Email'},
                {value: 'paymentSource', text: 'Payment Source '},
              ]"
              :select-size="2"
              v-model="exportForm.fields"
            ></b-form-select>
          </b-form-group>
          <div slot="footer" class="form-group">
            <b-button type="button" size="sm" variant="primary" v-on:click="exportDonations" ><i class="fa fa-search" ></i> Export</b-button>
          </div>
          <b-form-group
            v-if="exportData.length > 0"
          >
            Total: <strong>{{ totalDonations }}</strong>
          </b-form-group>
          <b-form-group>
            <download-csv
              class="btn btn-info"
              v-if="exportData.length > 0"
              :data="exportData"
            >
              Download Donations
            </download-csv>
          </b-form-group>
        </b-form>
    </div>
</template>
<script>
    import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
    import VueLoading from "vue-loading-overlay/src/js/Component";
    import {parseEnum} from "../../shared/utils";
    import {Donation} from "../../models/Donation";

    const ExportRepo = RepositoryFactory.get('export')

    export default {
      name: 'donation-export-form',
      components: {
        VueLoading,
      },
      data() {
          return {
            donationStatus: parseEnum(Donation.STATUS),
            exportForm: {
              status: '',
              fields: [],
            },
            totalDonations: 0,
            exportData: [],
            isLoading: false,
          }
        },
        methods: {
          exportDonations() {
                this.isLoading = true,
                this.exportData = [],
                ExportRepo
                    .exportDonations(this.exportForm)
                    .then(
                        response => (
                            this.isLoading = false,
                            this.totalDonations = response.data.data.donations.length,
                            this.exportData = response.data.data.donations
                        )
                    )
            },
        }
    }
</script>
<style>
  .form-group {
    margin-right: 10px;
  }
</style>
